import StatusChip from 'components/@extended/StatusChip';
import { Link as LinkIcon } from 'components/icons';
import { Link as RouterLink } from 'react-router-dom';
import { MatterFollowedPricelist, ScopeType } from 'types/pricelists';
import { t } from 'utils/getTranslations';

/** The name a follower shows for its list: a contract list that follows a model list goes by the model's name. */
export function followedPricelistName(followed: MatterFollowedPricelist): string {
    return (followed.scopeTypeCode === ScopeType.CONTRACT ? followed.modelPricelist?.name : null) ?? followed.name;
}

/**
 * The list a case follows. A contract list that follows a model list in turn is named by the model, whose periods
 * the case copies, and the contract it goes through follows it.
 */
export function FollowedPricelistLine({ followed }: { followed: MatterFollowedPricelist }): JSX.Element {
    const viaContract = followed.scopeTypeCode === ScopeType.CONTRACT ? followed.modelPricelist : null;
    const isModel = viaContract !== null || followed.scopeTypeCode !== ScopeType.CONTRACT;
    return (
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <LinkIcon className="text-grey-500 size-4 shrink-0" />
            <span className="font-medium">
                {t('pricelists.case-follow.follows', { name: followedPricelistName(followed) })}
            </span>
            <StatusChip
                type="neutral"
                label={t(isModel ? 'pricelists.case-follow.model-badge' : 'pricelists.case-follow.contract-badge')}
            />
            {viaContract ? (
                <span className="text-grey-500 text-xs">
                    {followed.contractId ? (
                        <RouterLink className="text-link hover:underline" to={`/contract/${followed.contractId}`}>
                            {t('pricelists.case-follow.through', { contract: followed.name })}
                        </RouterLink>
                    ) : (
                        t('pricelists.case-follow.through', { contract: followed.name })
                    )}
                </span>
            ) : null}
        </div>
    );
}
